export const ExternalLetterTemplateCodeLabel = "External Letter Template Code";
export const DisplayNameLabel = "Display Name";
export const FileTypeLabel = "File Type";
export const PatientSMSLabel = "Trigger Patient SMS";
export const FileNameLabel = "File Name";
